var map = {
	"./0.svg": "b91d",
	"./1.svg": "971b",
	"./10.svg": "c56b",
	"./11.svg": "02d6",
	"./12.svg": "b851",
	"./13.svg": "7663",
	"./14.svg": "eded",
	"./15.svg": "a021",
	"./16.svg": "e18f",
	"./17.svg": "4f48",
	"./18.svg": "c7cf",
	"./19.svg": "eddb",
	"./2.svg": "8d64",
	"./20.svg": "590d",
	"./21.svg": "4257",
	"./22.svg": "fca7",
	"./23.svg": "be5b",
	"./24.svg": "7399",
	"./25.svg": "4224",
	"./3.svg": "0b6c",
	"./4.svg": "9edb",
	"./5.svg": "a30b",
	"./6.svg": "feb8",
	"./7.svg": "f2da",
	"./8.svg": "fc63",
	"./9.svg": "125f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2494";